import { ref, get } from "firebase/database";
import React, { useEffect, useReducer } from "react";
import { RealDB } from "utils/config/firebase.config";

export type InfoState = any | null | undefined;

const authReducer = (state: InfoState, action: any) => {
  switch (action.type) {
    case "set":
      return action.payload;
    case "reset":
      return null;
  }
  return state;
};

export const InfoContext = React.createContext<InfoState>(null);

export const InfoProvider = ({ children }: { children: JSX.Element }) => {
  const [infoState, dispatch] = useReducer(authReducer, null);
  // const [infoState, setInfoState] = useState(undefined);
  InfoContext.displayName = "Info Context";
  useEffect(() => {
    init();
  }, []);
  const init = async () => {
    try {
      const snapshot = await get(ref(RealDB, "/config"));
      if (snapshot.exists()) {
        dispatch({ type: "set", payload: snapshot.val() });
      } else {
        throw Error("No data available");
      }
    } catch (error) {
      dispatch({ type: "reset" });
    }
  };
  return <InfoContext.Provider value={infoState}>{children}</InfoContext.Provider>;
};

export default InfoContext;
